import { login, logout, getInfo, getRouters,getbtn } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { filterAsyncRouter } from '../../utils'
import router, { constantRoutes } from '@/router.js'
import store from '@/store'

const user = {
  state: {
    token: getToken(),
    userInfo: null,
    name: '',
    permissions: [],
    permissionRoutes: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERINFO: (state, data) => {
      state.userInfo = data
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_PERMISSIONS: (state, permissions) => {
      console.log('进来了')
      state.permissions = permissions
      console.log(state.permissions)
    },
    SET_PERMISSIONROUTES: (state, routes) => {
      state.permissionRoutes = routes
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then((res) => {
            setToken(res.data.token)
            commit('SET_TOKEN', res.data.token)
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        console.log('login');
        getInfo()
          .then((res) => {
            console.log(res);
            const { user } = res.data
            console.log(user);
            commit('SET_USERINFO', user)
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 获取用户菜单权限
    GenerateRoutes({ commit }) {
      return new Promise((resolve, reject) => {
        // 向后端请求路由数据
        getRouters().then((res) => {
          const accessedRoutes = filterAsyncRouter(res.data)
          accessedRoutes.push({ path: '*', redirect: '/404', hidden: true })
          // commit('SET_ROUTES', constantRoutes.concat(accessedRoutes))
          router.options.routes = accessedRoutes
          resolve(accessedRoutes)
        })
      })

    },

    // 获取用户权限操作信息
    GetPermissions({ commit }) {
      return new Promise((resolve, reject) => {
        // 获取用户权限操作
        getbtn().then((res) => {
          const { code, data } = res
          if (code === 200) {
            commit('SET_PERMISSIONS', data)
            sessionStorage.setItem('btnList', JSON.stringify(data))
          }
          resolve(res)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    // 退出系统
    LogOut({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            commit('SET_TOKEN', '')
            sessionStorage.clear()
            removeToken()
            resolve()
            // reset visited views and cached views
            // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
            dispatch('tagsView/delAllViews', null, { root: true })
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit('SET_TOKEN', '')
      removeToken()
      resolve()
    })
  }
}

export default user
